import { useContext } from 'react';
import { ThemeContext } from '@lib/context/theme';

export function useTheme() {
  return useContext(ThemeContext);
}

export default useTheme;
